/**
 * Working title of a Bulk Creation row, prefilled from a motif file name
 * (R20): extension and a trailing front/back suffix are stripped.
 */

/** Maximum length of a derived working title. */
export const BULK_TITLE_MAX_LENGTH = 100;

const SIDE_SUFFIX = /[_\- ](front|back)$/i;

function stripExtension(fileName: string): string {
  const dot = fileName.lastIndexOf('.');
  // A leading dot (".hidden") is part of the name, not an extension.
  return dot > 0 ? fileName.slice(0, dot) : fileName;
}

/**
 * `Motiv_01_front.PNG` → `Motiv_01`. Falls back to the name without
 * extension when stripping the suffix leaves nothing.
 */
export function deriveTitle(fileName: string): string {
  const base = stripExtension(fileName.normalize('NFC')).trim();
  const stripped = base.replace(SIDE_SUFFIX, '').trim();
  const title = stripped.length > 0 ? stripped : base;
  // Cap by code points so an emoji at the boundary is not split in half.
  return Array.from(title).slice(0, BULK_TITLE_MAX_LENGTH).join('');
}
